import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopyright} from "@awesome.me/kit-2be97ecbd6/icons/sharp/light";

import styles from './DataSource.module.css';

function DataSource({dataSource}) {
  if (!dataSource) {
    return null;
  }

  return (
    <div className={styles.DataSourceInfo}>
      <OverlayTrigger
        overlay={(props) =>
          <Tooltip
            customClass={styles.DataSourceTooltip}
            id={`datasource-tooltip`}
            {...props}
          >
            &copy; {dataSource}
          </Tooltip>
        }
      >
        <FontAwesomeIcon icon={faCopyright} style={{padding: '0.5em'}}/>
      </OverlayTrigger>
    </div>
  )
}

export default DataSource
